import { borderRadii, shadows } from '@pcln/brand'
import { theme } from 'pcln-design-system'

const mobile = 413
const mobilelg = 414
const tablet = 600
const tabletlg = 768
const tablethd = 840
const desktop = 1024
const desktoplg = 1280
const desktophd = 1440

const flyQueries = {
  mobile: `@media screen and (max-width: ${mobile}px)`,
  mobilelg: `@media screen and (min-width: ${mobilelg}px)`,
  tablet: `@media screen and (min-width: ${tablet}px)`,
  tabletlg: `@media screen and (min-width: ${tabletlg}px)`,
  tablethd: `@media screen and (min-width: ${tablethd}px)`,
  desktop: `@media screen and (min-width: ${desktop}px)`,
  desktoplg: `@media screen and (min-width: ${desktoplg}px)`,
  desktophd: `@media screen and (min-width: ${desktophd}px)`,
}

const flyBreakPoints = {
  mobile,
  mobilelg,
  tablet,
  tabletlg,
  tablethd,
  desktop,
  desktoplg,
  desktophd,
}

export { flyQueries, flyBreakPoints }

export const getTheme = (partnerCode) =>
  !partnerCode
    ? Object.assign({}, theme, {
        flyQueries,
        flyBreakPoints,
        borderRadii,
        shadows,
      })
    : Object.assign({}, theme, { flyQueries, flyBreakPoints })
